const { id, log, max, min } = require("../std/index")


//
// Fading BG
//
// Background image fades away when page is scrolled
//

module.exports = class FadingBackground {
  constructor($host, config) {
    this.minOpacity = 0.4;
    this.fadeDistance = 400;

    this.dom = {
      main: $host,
      img: $('img', $host)
    };

    $(document).on('scroll', () => {
      this.update($(document).scrollTop());
    });
  }

  update(scrolltop) {
    this.dom.main.css({ opacity: min(1.0, max(this.minOpacity, 1 - (scrolltop / this.fadeDistance))) });
  }
};
